import {ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {AppService} from '@app/app.service';
import {SelectService} from '../select-service.service';
import {SelectSearchLoad} from '@app/core/libraries/Dynamic-fields/components/select/classes/SelectSearchLoad.class';
import {HttpClient} from '@angular/common/http';
import {MatLegacySelect as MatSelect} from '@angular/material/legacy-select';
import {TuiDestroyService} from '@taiga-ui/cdk';

@Component({
    selector: 'app-select-search-load',
    templateUrl: './select-search-load.component.html',
    styleUrls: ['./../select.scss', '../../../../../shared/components/button/styles/button.scss'],
    providers: [SelectService, TuiDestroyService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectSearchLoadComponent extends SelectSearchLoad implements OnInit {

    @ViewChild('matSelect', {static: false}) declare matSelect: MatSelect;

    constructor(
        @Inject(TuiDestroyService) protected _destroy$: TuiDestroyService,
        public appService: AppService,
        public deviceService: DeviceDetectorService,
        public service: SelectService,
        public http: HttpClient
    ) {
        super(_destroy$, service, http, appService);
    }

    public showSpinner() {
        this.service.isShowSpinner.next(true);
    }

    public hideSpinner() {
        this.service.isShowSpinner.next(false);
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.service.field.disabled = disabled;
        if (this.service.field.disabled) {
            this.service.group.get(this.service.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.service.group.get(this.service.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }
}

